var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sections"},[_vm._l((_vm.structuredSections),function(section,index){return [_c(_vm.sanitizeSectionTemplate(section.attributes.template),{key:index,tag:"div",attrs:{"section":section}},[(section.children && section.children.length)?_c('SectionsLoop',{attrs:{"sections":section.children}}):_vm._e()],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }